import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { Coverage as CoverageContent } from 'Coverage';

const Coverage = () => (
  <AppLayout>
    <CoverageContent />
  </AppLayout>
);

export default Coverage;
